import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  Button,
  Col,
  Divider,
  Form,
  Modal,
  Popconfirm,
  Row,
  Space,
  Spin,
  Typography,
} from "antd";
import { InputFields, ModalCustom } from "components/common";
import {
  dataAnamnesis,
  dataExamine,
  dataInfoHospitalise,
  patientInfo,
  thiLucCoKinh,
  thiLucKhongKinh,
} from "./config";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { btnProps } from "types/enums/btnProps";
import { PrintColorWhiteSVG, SaveWhiteIconSVG } from "assets";
import { ReactComponent as WordSVG } from "assets/images/svg/word.svg";
import Icons from "assets/icons";
import Notification from "components/common/notification/notification";
import {
  inpatientService,
  medicalExaminationService,
  residentialNurseService,
} from "api";
import dayjs from "dayjs";
import { toDateTime } from "helper/format-date";
import {
  birthday2Age,
  convertIosStringToDate,
  convertIosStringToDate2,
  convertIosStringToDateObjectDayjs,
  isValuable,
  toArray,
} from "helper/common";
import TypographyCommon from "./TypographyCommom/TypographyCommon";
import Consultation from "./components/Consultation/Consultation";
import TreatmentSheet from "./components/TreatmentSheet/TreatmentSheet";
import LessCondition from "./components/LessCondition/LessCondition";
import PatientInfoCommon from "./PatientInfoCommon/PatientInfoCommon";
import PrescriptionTable from "./PrescriptionTable/PrescriptionTable";
import TreatmentTypeModal from "./components/TreatmentTypeModal/TreatmentTypeModal";
import PrintComeHospital from "./components/PrintComeHospital/PrintComeHospital";
import PhieuChiDinhXetNghiem from "./components/PhieuChiDinhXetNghiem/PhieuChiDinhXetNghiem";
import ToDieuTri from "./components/ToDieuTri/ToDieuTri";
import { FORMAT_TIME, tabKeys } from "types/enums";
import { residentialNurse } from "types/enums/residential-nurse";

import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertFromRaw,
  convertToRaw,
  convertFromHTML,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { fontOptions } from "pages/Electrocardiography/tabs/DetailDiagnose/ElectrocardiographyInfo/TextEditor";
import "./TreatmentInfo.scss";
import { DeleteOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import CheckDataKhamMat from "./CheckKhamMat/CheckDataKhamMat";
import PhieuTienPhau from "./components/PhieuTienPhau/PhieuTienPhau";
import {
  setDataPhieuDieuTri,
  setIsChangetab,
  setThongTinBNDieuTri,
} from "redux/reducer/residentialNurse";
import PhuThuModal from "./components/PhuThuModal/PhuThuModal";
import MedicalExaminationService from "api/medicalExamination";
import PhieuTienPhauPrint from "./components/PhieuTienPhau/PhieuTienPhauPrint";
import { setActiveKey } from "redux/reducer/common";
interface cstMng {
  idx: number;
  data: any;
  lanSuaCuoi: string;
  by: string;
}
interface tmMng {
  idx: number;
  data: any;
  lanSuaCuoi: string;
  by: string;
}

const mapDonThuoc = (donThuoc) => {
  return donThuoc.map((it) => {
    delete it.id;
    return it;
  });
};
function customCompare(a, b) {
  if (!a && !b) {
    return;
  }
  let objA = JSON.parse(a.toDieuTri);
  let objB = JSON.parse(b.toDieuTri);

  let dateA = objA.table.row0.ngay;
  let timeA = objA.table.row0.gio;

  let dateB = objB.table.row0.ngay;
  let timeB = objB.table.row0.gio;

  if (dateA === null && dateB === null) {
    // So sánh theo thuộc tính "date" nếu cả hai có giá trị null
    if (timeA === null && timeB === null) {
      return 0;
    } else if (timeA === null) {
      return 1;
    } else if (timeB === null) {
      return -1;
    }
  } else if (dateA === null) {
    return 1;
  } else if (dateB === null) {
    return -1;
  } else if (dateA > dateB) {
    return 1;
  } else if (dateA < dateB) {
    return -1;
  }

  // Chuyển đổi chuỗi "HH:mm" thành số (phút) để so sánh
  let minutesA =
    parseInt(timeA?.split(":")?.[0]) * 60 + parseInt(timeA?.split(":")?.[1]);
  let minutesB =
    parseInt(timeB?.split(":")?.[0]) * 60 + parseInt(timeB?.split(":")?.[1]);

  if (minutesA < minutesB) {
    return -1;
  } else if (minutesA > minutesB) {
    return 1;
  } else {
    return 0;
  }
}
const TreatmentInfo = () => {
  const idDDNT = useAppSelector((state) => state.residentialNurse.idDDNT);
  const chiDinhref = useRef<any>();

  const cstRef = useRef<any>(null);
  const [cstMngs, setCstMngs] = useState<cstMng[]>([]);
  const treatmentRef = useRef<any>(null);
  const donThuocRef = useRef<any>(null);
  const conditionRef = useRef<any>(null);
  const [infoForm] = Form.useForm();
  const [hopitalizeForm] = Form.useForm();
  const treatmentTRef = useRef<any>();
  const tienPhauRef = useRef<any>();
  const tienPhauPrintRef = useRef<any>();
  const phuThuRef = useRef<any>();
  const [donThuoc, setDonThuoc] = useState<any>(null);
  const [donThuocPhu, setDonThuocPhu] = useState<any>(null);

  //state
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [thongTinBN, setThongTinBN] = useState<any>(null);
  const printComeHotpitalRef = useRef<any>();

  const dispatch = useAppDispatch();
  const activeTab = useAppSelector((e) => e.common.activeTab);
  // console.log("🚀 ~ TreatmentInfo ~ activeTab:", activeTab);

  //editorState
  const [dataEditorLeft, setDataEditorLeft] = useState("");

  const [dataEditorRight, setDataEditorRight] = useState("");
  let [thongTinDieuTri, setThongTinDieuTri] = useState<any>(null);

  const [editorStateLeft, setEditorStateLeft] = useState(null);
  const [editorStateRight, setEditorStateRight] = useState(null);
  const [phieuTienPhau, setPhieuTienPhau] = useState(null);
  const onEditorStateChangeLeft = useCallback((editorState) => {
    setEditorStateLeft(editorState);
  }, []);
  const onEditorStateChangeRight = useCallback((editorState) => {
    setEditorStateRight(editorState);
  }, []);

  // **************************
  const pCDXNRef = useRef<any>();
  const tDTRef = useRef<any>();

  const handleTTConfirm = async (treatmentType, listTDT) => {
    await onAddTreatmentSheet(treatmentType, listTDT);
  };
  // const printTreatment = async (data, isView, kind) => {
  //   treatmentRef.current?.setPrint(true);
  //   treatmentRef.current?.setKind(kind);
  //   treatmentRef.current?.openModal(isView);
  //   treatmentRef.current?.setData({
  //     ...data,
  //   });
  // };
  const viewTreatment = async (data, isView, kind, isViewDichVu) => {
    treatmentRef.current?.setPrint(false);
    treatmentRef.current?.setKind(kind);
    treatmentRef.current?.openModal(isView);
    treatmentRef.current?.setData({
      ...thongTinBN,
      ...data,
      // ...thongTinDieuTri
    });
    treatmentRef.current?.setIsViewDichVu(isViewDichVu);
  };
  //biên bản hội chẩn
  const viewCST = async (idx, isView) => {
    cstRef.current?.resetFields();

    cstRef.current?.openModal(isView);
    cstRef.current?.setIdx(idx);
    let tmp = cstMngs.find((it) => it.idx === idx)?.data;
    cstRef.current?.setValues({
      ...tmp,
      buong: thongTinBN?.idBuongSo,
      giuong: thongTinBN?.idGiuongSo,
    });
    console.log("🚀 ~ viewCST ~ thongTinDieuTri:", thongTinBN);
    cstRef.current?.setPrint(false);
  };

  const deleteCST = async (idx) => {
    let tmp = cstMngs.filter((it) => it.idx !== idx);

    form.validateFields().then(async (values) => {
      let data = {
        ...thongTinDieuTri,
        id: idDDNT,
        idPhieuKham: thongTinBN.idPhieuKham,
        ...hopitalizeForm.getFieldsValue(),
        lyDoKhongDuDieuKienPhauThuat:
          thongTinDieuTri.lyDoKhongDuDieuKienPhauThuat,
        bienBanHoiChan: JSON.stringify(tmp),
        toDieuTri: thongTinDieuTri.toDieuTri,
        dieuTriNoiTruDonThuocDtoList: mapDonThuoc(
          thongTinDieuTri.dieuTriNoiTruDonThuocDtoList
        ),
        ...values,
        taiKham: values?.taiKham?.format("DD/MM/YYYY"),
      };
      try {
        let response = await inpatientService.putLuuThongTinDieuTriNoiTru(data);
        setThongTinDieuTri(response);
        Notification("success", "Xóa thành công!");
      } catch (err) {
        Notification("error", "Xóa không thành công");
      }
    });
    setCstMngs(tmp);
  };

  const printBBHC = async (idx, isView) => {
    cstRef.current?.resetFields();
    cstRef.current?.setPrint(true);
    cstRef.current?.openModal(isView);
    cstRef.current?.setIdx(idx);
    let tmp = cstMngs.find((it) => it.idx === idx)?.data;
    cstRef.current?.setThongTinBN({
      ...thongTinBN,
      ...tmp,
      buong: thongTinBN?.idBuongSo,
      giuong: thongTinBN?.idGiuongSo,
      maBenhNhan: thongTinBN?.maBenhNhan,
      icd: thongTinDieuTri?.chanDoan,
      maIcd: thongTinDieuTri?.icdChanDoan,
      gioiTinh: thongTinBN?.gioiTinh,
    });
  };

  const handleSave = async (type?, value?) => {
    return new Promise((resolve, reject) => {
      if (idDDNT == null) {
        Notification("error", "Chưa có thông tin bênh nhân!");
        return;
      }
      form.validateFields().then(async (values) => {
        let data = {
          id: idDDNT,
          idPhieuKham: thongTinBN.idPhieuKham,
          bienBanHoiChan: thongTinDieuTri.bienBanHoiChan,
          toDieuTri: thongTinDieuTri.toDieuTri,
          lyDoKhongDuDieuKienPhauThuat:
            type === 1
              ? conditionRef.current.getValue("lyDoKhongDuDieuKienPhauThuat")
              : thongTinDieuTri.lyDoKhongDuDieuKienPhauThuat,
          dieuTriNoiTruDonThuocDtoList: donThuocRef.current.getData(idDDNT),
          ...hopitalizeForm.getFieldsValue(),
          khamMatMatPhai: editorStateRight
            ? draftToHtml(convertToRaw(editorStateRight.getCurrentContent()))
            : "",
          khamMatMatTrai: editorStateLeft
            ? draftToHtml(convertToRaw(editorStateLeft.getCurrentContent()))
            : "",
          phieuTienPhau: value ?? thongTinDieuTri?.phieuTienPhau,
          ...values,
          taiKham: values?.taiKham?.format("DD/MM/YYYY"),
        };

        try {
          let response = await inpatientService.putLuuThongTinDieuTriNoiTru(
            data
          );
          setPhieuTienPhau(response.phieuTienPhau);
          tienPhauRef.current.setDataPhieu(response.phieuTienPhau);
          setThongTinDieuTri(response);
          postDonThuoc();
          Notification("success", "Lưu thành công!");
          resolve(true);
          dispatch(setIsChangetab(false));
        } catch (err) {
          resolve(false);
          Notification("error", "Lưu không thành công!");
        }
      });
    });
  };
  const handleSaveConsultation = async (type, idx) => {
    if (idDDNT == null) {
      Notification("error", "Chưa có thông tin bệnh nhân");
      return;
    }
    let tmp;
    if (type === 0) {
      // add
      tmp = [
        ...cstMngs,
        {
          idx: cstMngs.length,
          data: cstRef.current.getValues(),
          lanSuaCuoi:
            cstRef.current
              .getValue("thoiGianHoiChan")
              ?.format("HH:mm DD/MM/YYYY") ?? "",
          by: localStorage.getItem("fullName"),
        },
      ];
      setCstMngs(tmp);
    }
    if (type === 1) {
      // update
      tmp = cstMngs.map((it) => {
        if (it.idx === idx) {
          return {
            idx: idx,
            data: cstRef.current.getValues(),
            lanSuaCuoi:
              cstRef.current
                .getValue("thoiGianHoiChan")
                ?.format("HH:mm DD/MM/YYYY") ?? "",
            by: localStorage.getItem("fullName"),
          };
        } else return { ...it };
      });
      setCstMngs(tmp);
    }

    if (idDDNT == null) {
      Notification("error", "Chưa có thông tin bênh nhân!");
      return;
    }

    form.validateFields().then(async (values) => {
      let _dt = tmp.map((it) => {
        const { buong, giuong, ...rest } = it.data;
        return {
          data: { ...rest },
          lanSuaCuoi: it.lanSuaCuoi,
          by: it.by,
        };
      });

      let data = {
        ...thongTinDieuTri,
        id: idDDNT,
        ...hopitalizeForm.getFieldsValue(),
        idPhieuKham: thongTinBN.idPhieuKham,
        lyDoKhongDuDieuKienPhauThuat:
          thongTinDieuTri.lyDoKhongDuDieuKienPhauThuat,
        bienBanHoiChan: JSON.stringify(_dt),
        toDieuTri: thongTinDieuTri.toDieuTri,
        dieuTriNoiTruDonThuocDtoList: mapDonThuoc(
          thongTinDieuTri.dieuTriNoiTruDonThuocDtoList
        ),
        ...values,
        taiKham: values?.taiKham?.format("DD/MM/YYYY"),
      };
      try {
        let response = await inpatientService.putLuuThongTinDieuTriNoiTru(data);
        setThongTinDieuTri(response);
        Notification("success", "Lưu thành công!");
      } catch (err) {
        Notification("error", "Lưu không thành công!");
      }
    });
  };

  const handleSaveTreatment = async (type, kind) => {
    if (idDDNT === null) {
      Notification("error", "Chưa có thông tin bệnh nhân");
      return;
    }
    if (type === 0) {
      // add
      let data = {
        idPhieuDieuTriNoiTru: idDDNT,
        ...treatmentRef.current?.getData(),
      };

      try {
        let response = await inpatientService.postToDieuTri(data);
        if (treatmentRef.current?.getSavedServices() !== null) {
          await treatmentRef.current?.serviceSave(response.id);
        }
        if (treatmentRef.current?.getSavedMedicals() !== null) {
          await treatmentRef.current?.medicineSave(response.id);
        }
        fetchThongTinDieuTri();
        Notification("success", "Thêm thành công!");
      } catch (err) {
        console.log("🚀 ~ handleSaveTreatment ~ err:", err);
        Notification("error", "Thêm không thành công!");
      }
    }
    if (type === 1) {
      // update
      let data = {
        idPhieuDieuTriNoiTru: idDDNT,
        ...treatmentRef.current?.getData(),
      };
      try {
        let response = await inpatientService.putToDieuTri(data);
        fetchThongTinDieuTri();
        Notification("success", "Lưu thành công!");
      } catch (err) {
        Notification("error", "Lưu không thành công!");
      }
    }
  };

  const onAddCST = async () => {
    cstRef.current?.resetToNew({
      ...thongTinBN,
      icd: thongTinDieuTri?.chanDoan,
      maIcd: thongTinDieuTri?.icdChanDoan,
      chanDoan: thongTinDieuTri?.chanDoan,
      icdChanDoan: thongTinDieuTri?.icdChanDoan,
    });
    cstRef.current?.setIcdList(icdList);
    cstRef.current?.openModal();
    cstRef.current?.setPrint(false);
  };
  const onSelectTType = async (isViewDichVu) => {
    const roles = localStorage.getItem("roles");
    // console.log("🚀 ~ onSelectTType ~ roles:", typeof roles);
    if (!roles.includes("bac_si")) {
      Notification(
        "warning",
        "Bạn không có quyền tạo tờ điều trị. Vui lòng truy cập vào tài khoản bác sĩ!"
      );
      return;
    }
    treatmentTRef.current?.openModal();
    treatmentRef.current?.setIsViewDichVu(isViewDichVu);
  };
  const onAddTreatmentSheet = async (kind, listTDT) => {
    treatmentRef.current?.setPrint(false);
    treatmentRef.current?.setData({
      ...thongTinBN,
      hoTen: thongTinBN.tenBenhNhan,
      id: null,
      icd: thongTinDieuTri?.icdChanDoan,
      maIcd: thongTinDieuTri?.chanDoan,
    });

    treatmentRef.current?.setKind(kind);
    // treatmentRef.current?.setListTDT(listTDT);
    treatmentRef.current?.openModal();
  };
  const [dmBuong, setDmBuong] = useState<any>([]);
  const [dmGiuong, setDmGiuong] = useState<any>([]);
  const fetchDanhMucGiuongBenh = async (params) => {
    try {
      let response = await inpatientService.getListDanhMucGiuongBenh(params);
      setDmGiuong(response.data);
    } catch (err) {}
  };
  const fetchDanhMucPhongBenh = async (params) => {
    try {
      let response = await inpatientService.getListDanhMucPhongBenh(params);
      setDmBuong(response.data);
    } catch (err) {}
  };
  const [icdList, setIcdList] = useState<any>([]);
  const getIcdList = async () => {
    setLoading(true);
    const response = await medicalExaminationService.getIcdList();
    setIcdList(response.data);
    setLoading(false);
  };
  const onPrintTDT = async () => {
    if (thongTinDieuTri?.toDieuTriDtoList?.length > 0) {
      tDTRef.current?.setThongTinBN({
        ...thongTinBN,
      });
      tDTRef.current?.setDataPhieu({
        // ...thongTinBN,
        ...thongTinDieuTri,
      });
      tDTRef.current?.openModal();
    } else {
      Notification("warning", "Chưa có tờ điều trị!");
    }
  };
  const onPrintPCDXN = async () => {
    if (thongTinDieuTri?.toDieuTriDtoList?.length > 0) {
      let countCD = 0;
      thongTinDieuTri.toDieuTriDtoList.map((it) => {
        countCD += it.phieuChiDinhDtos.length;
      });
      if (countCD > 0) {
        dispatch(setThongTinBNDieuTri(thongTinBN));
        dispatch(setDataPhieuDieuTri(thongTinDieuTri));
        // pCDXNRef.current?.setThongTinBN({
        //   ...thongTinBN,
        // });
        // pCDXNRef.current?.setDataPhieu({
        //   ...thongTinDieuTri,
        // });
        // pCDXNRef.current.openModal()
        chiDinhref.current?.openModal();
      } else {
        Notification("warning", "Chưa có chỉ định!");
      }
    } else {
      Notification("warning", "Chưa có tờ điều trị!");
    }
  };
  useEffect(() => {}, [cstMngs]);

  useEffect(() => {
    if (
      (idDDNT === 0 || idDDNT) &&
      activeTab === residentialNurse.TREATMENT.TREATMENT_INFO
    ) {
      getThongTinBenhNhanAPI();
      fetchThongTinDieuTri();
    } else {
      setEditorStateLeft(null);
      setEditorStateRight(null);
      setDataEditorLeft("");
      setDataEditorRight("");
      setThongTinBN(null);
      setThongTinBNDieuTri(null);
      setThongTinDieuTri(null);
    }
  }, [idDDNT, activeTab]);
  useEffect(() => {
    if (thongTinBN) {
      infoForm.setFieldsValue({
        ...thongTinBN,
        thoiGianNhapVien: toDateTime(
          thongTinBN.ngayNhapVien,
          "YYYY-MM-DDTHH:mm:ss"
        ),
        ngayNhapVien: convertIosStringToDate(thongTinBN.ngayNhapVien),
        ngayChiDinh: convertIosStringToDateObjectDayjs(thongTinBN.ngayChiDinh),
      });
    }
    if (thongTinBN?.icdChanDoan && thongTinBN?.chanDoan) {
      const data =
        (thongTinBN?.icdChanDoan
          ? thongTinBN?.icdChanDoan.replace("\n", "") + " - "
          : "") + thongTinBN?.chanDoan?.replace("\n", "");
      patientInfo.find((e) => {
        if (e.name === "chanDoan") {
          infoForm.setFieldValue("chanDoan", data);
        }
      });
    }
  }, [thongTinBN]);

  const getThongTinBenhNhanAPI = async () => {
    try {
      setLoading(true);
      let response = await inpatientService.getThongTinBenhNhan(idDDNT);

      setThongTinBN(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Notification("error", "Lỗi khi lấy thông tin bệnh nhân!");
    }
  };
  const fetchThongTinDieuTri = async () => {
    try {
      setLoading(true);
      let response = await inpatientService.getThongTinDieuTriNoiTru({
        id: idDDNT,
      });
      setThongTinDieuTri(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const onLessCondition = async () => {
    conditionRef.current?.openModal();
  };
  const toSurgery = async () => {
    if (idDDNT === null) {
      Notification("error", "Chưa có thông tin bệnh nhân!");
      return;
    }
    try {
      let response = await inpatientService.putDuDieuKienPT(idDDNT);
      Notification("success", "Thành công!");
    } catch (err) {
      Notification("error", "Lỗi xảy ra!");
    }
  };
  const fetchDonThuocByIdPhieuDieuTru = async () => {
    try {
      setLoading(true);
      let response = await inpatientService.getListThuocChinhByIdPhieuDieuTri(
        idDDNT
      );
      if (JSON.stringify(response) !== "[]") {
        setDonThuoc(response);
      } else {
        setDonThuoc(null);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      // notification.error({message: "Lỗi khi lấy thông tin đơn thuốc!"})
    }
  };
  const fetchDonThuocPhuByIdPhieuDieuTri = async () => {
    try {
      setLoading(true);
      let response = await inpatientService.getListThuocPhuByIdPhieuDieuTri(
        idDDNT
      );
      if (JSON.stringify(response) !== "[]") {
        setDonThuocPhu(response);
      } else {
        setDonThuocPhu(null);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      // notification.error({message: "Lỗi khi lấy thông tin đơn thuốc!"})
    }
  };
  useEffect(() => {
    if (isValuable(idDDNT)) {
      fetchDonThuocByIdPhieuDieuTru();
      fetchDonThuocPhuByIdPhieuDieuTri();
    }
  }, [idDDNT]);
  useEffect(() => {
    donThuocRef?.current?.setDataSource([
      ...toArray(donThuoc?.thuocs),
      ...toArray(donThuocPhu?.thuocs),
    ]);
  }, [donThuoc, donThuocPhu]);
  const onCompleteTreatment = async () => {
    if (idDDNT == null) {
      Notification("error", "Chưa có thông tin bệnh nhân!");
    }
    try {
      await handleSave().then(async (res) => {
        if (res) {
          let response = await inpatientService.putHoanThanhDieuTri(idDDNT);
          Notification("success", "Hoàn thành điều trị!");
        }
      });
      postDonThuoc();
    } catch (err) {
      console.log("🚀 ~ onCompleteTreatment ~ err:", err);
      Notification("error", "Lỗi xảy ra!");
    }
  };
  const removeNullDonThuoc = (dt) => {
    let res = [];
    dt.map((it, index) => {
      it.tenThuoc && it.tenThuoc !== "" && it.tenThuoc !== undefined
        ? (res = [...res, { ...it, thuTu: index }])
        : null;
    });
    return res;
  };
  //Post đơn thuốc
  const postDonThuoc = async () => {
    const dataSource = donThuocRef?.current?.getDataSource();
    const thuocs = removeNullDonThuoc(toArray(dataSource));
    const thuocChinh = thuocs.filter((e) => isValuable(e?.idThuoc));
    const thuocPhu = thuocs.filter((e) => !isValuable(e?.idThuoc));

    const data = {
      thuocs: thuocChinh,
      trangThai: donThuoc?.trangThai,
      idPhieuDieuTriNoiTru: idDDNT,
      id: donThuoc?.id,
    };
    const dataPhu = {
      thuocs: thuocPhu,
      trangThai: donThuocPhu?.trangThai,
      idPhieuDieuTriNoiTru: idDDNT,
      id: donThuocPhu?.id,
    };
    let callApiThuoc = donThuoc
      ? inpatientService.putDonThuocChinh
      : inpatientService.postDonThuocChinh;
    let callApiThuocPhu = donThuocPhu
      ? inpatientService.putDonThuocPhu
      : inpatientService.postDonThuocPhu;
    let response = await callApiThuoc(data);
    let responsePhu = await callApiThuocPhu(dataPhu);
    setDonThuoc(response);
    setDonThuocPhu(responsePhu);
    // try {
    //   await MedicalExaminationService
    //   Notification("success", "Gửi đơn thuốc thành công");
    // } catch (error) {
    //   Notification("error", "Gửi đơn thuốc không thành công");
    // }
  };
  //lay dữ liệu đổ vào phiếu khám vào viện
  const canNang = Form.useWatch("canNang", hopitalizeForm);
  const chieuCao = Form.useWatch("chieuCao", hopitalizeForm);
  useMemo(() => {
    let tmp = Number(canNang) / Math.pow(Number(chieuCao) / 100, 2);
    if (tmp && !isNaN(tmp) && isFinite(tmp))
      hopitalizeForm.setFieldValue("bmi", tmp.toFixed(1));
    else hopitalizeForm.setFieldValue("bmi", null);
  }, [canNang]);

  useMemo(() => {
    let tmp = Number(canNang) / Math.pow(Number(chieuCao) / 100, 2);
    if (tmp && !isNaN(tmp) && isFinite(tmp))
      hopitalizeForm.setFieldValue("bmi", tmp.toFixed(1));
    else hopitalizeForm.setFieldValue("bmi", null);
  }, [chieuCao]);

  const onPrintBill = async () => {
    printComeHotpitalRef.current.setDataPhieu({
      ...thongTinBN,
      ...thongTinDieuTri,
    });
    printComeHotpitalRef.current?.openModal();
  };

  //Các btn
  const btnComInHospital: btnProps[] = [
    {
      title: "In phiếu khám vào viện",
      className: "btn-sub",
      type: "primary",
      onClick: onPrintBill,
      icons: <PrintColorWhiteSVG />,
    },
    {
      title: "Không đủ điều kiện phẫu thuật",
      className: "custom-btn",
      type: "primary",
      danger: true,
      onClick: onLessCondition,
    },
    {
      title: (
        <Popconfirm title="Chuyển qua phòng phẫu thuật?" onConfirm={toSurgery}>
          Đủ điều kiện phẫu thuật
        </Popconfirm>
      ),
      className: "btn-sub",
      type: "primary",
    },
    {
      title: "Hoàn thành",
      className: "custom-btn",
      type: "primary",
      onClick: onCompleteTreatment,
    },
    {
      title: "Lưu lại",
      className: "custom-btn",
      type: "primary",
      onClick: handleSave,
      icons: <SaveWhiteIconSVG />,
    },
  ];

  const resetFields = () => {
    form.resetFields();
    treatmentRef.current?.resetFields();
    conditionRef.current?.resetFields();
  };
  const delToDieuTri = async (dt) => {
    try {
      let response = await inpatientService.deleteToDieuTri({ id: dt.id });

      await fetchThongTinDieuTri();
      Notification("success", "Xoá thành công!");
    } catch (err) {
      Notification("error", "Xoá không thành công!");
    }
  };
  useEffect(() => {
    resetFields();
    if (thongTinDieuTri) {
      form.setFieldsValue({
        ketLuanBacSy: thongTinDieuTri?.ketLuanBacSy,
        taiKham: thongTinDieuTri?.taiKham
          ? dayjs(thongTinDieuTri?.taiKham, "DD/MM/YYYY")
          : null,
      });
      if (thongTinDieuTri?.phieuTienPhau) {
        // console.log(thongTinDieuTri);

        setPhieuTienPhau(thongTinDieuTri?.phieuTienPhau);
      }
      if (thongTinDieuTri.bienBanHoiChan) {
        let bienBanHoiChan = JSON.parse(thongTinDieuTri.bienBanHoiChan);
        let tmp = [];
        bienBanHoiChan.map((it) => {
          tmp = [
            ...tmp,
            {
              idx: tmp.length,
              data: it.data,
              lanSuaCuoi: it.lanSuaCuoi,
              by: it.by,
            },
          ];
        });
        setCstMngs(tmp);
      } else {
        setCstMngs([]);
      }
      // donThuocRef.current?.setDataSource(
      //   thongTinDieuTri.dieuTriNoiTruDonThuocDtoList
      // );
      conditionRef.current?.setValue(
        "lyDoKhongDuDieuKienPhauThuat",
        thongTinDieuTri.lyDoKhongDuDieuKienPhauThuat
      );
      hopitalizeForm.setFieldsValue({
        ...thongTinDieuTri,
        daXuLy: thongTinDieuTri?.daXuLy ?? "Không",
      });
      if (
        thongTinDieuTri?.benhChuyenKhoa === null ||
        thongTinDieuTri?.benhChuyenKhoa === "" ||
        !thongTinDieuTri?.benhChuyenKhoa
      ) {
        hopitalizeForm.setFieldsValue({
          benhChuyenKhoa: "Tim nhịp đều, phổi không rale",
        });
      }

      if (
        thongTinDieuTri?.khamXetToanThan === null ||
        thongTinDieuTri?.khamXetToanThan === "" ||
        !thongTinDieuTri?.khamXetToanThan
      ) {
        hopitalizeForm.setFieldsValue({
          khamXetToanThan: "Tỉnh, toàn trạng ổn định",
        });
      }
      if (thongTinDieuTri?.chanDoanNoiGioiThieu) {
        hopitalizeForm.setFieldValue(
          "chanDoanNoiGioiThieu",
          thongTinDieuTri?.chanDoanNoiGioiThieu
        );
      } else {
        if (thongTinDieuTri?.chanDoan) {
          hopitalizeForm.setFieldValue(
            "chanDoanNoiGioiThieu",
            thongTinDieuTri?.chanDoan
          );
        } else hopitalizeForm.setFieldValue("chanDoanNoiGioiThieu", null);
      }
    }

    if (!thongTinDieuTri?.mp) {
      hopitalizeForm;
    }
    //Thị lực không kính và có kính phải
    if (
      thongTinDieuTri?.mp &&
      (!thongTinDieuTri?.thiLucKhongKinhMatPhai ||
        !thongTinDieuTri.thiLucCoKinhMatPhai)
    ) {
      const jsonMp = JSON.parse(thongTinDieuTri?.mp);
      if (jsonMp?.ucva1) {
        hopitalizeForm.setFieldsValue({
          thiLucKhongKinhMatPhai:
            jsonMp?.ucva1 &&
            jsonMp?.ucva1 +
              (jsonMp?.ucva1Value ? `(${jsonMp?.ucva1Value})` : ""),
          thiLucCoKinhMatPhai:
            jsonMp?.glasses1 &&
            jsonMp?.glasses1 +
              (jsonMp?.glasses1Value ? `(${jsonMp?.glasses1Value})` : ""),
        });
      }
    } else {
      hopitalizeForm.setFieldsValue({
        thiLucKhongKinhMatPhai: thongTinDieuTri?.thiLucKhongKinhMatPhai,
        thiLucCoKinhMatPhai: thongTinDieuTri?.thiLucCoKinhMatPhai,
      });
    }
    //Thị lực không kính và có kính trái
    if (
      thongTinDieuTri?.mt &&
      (!thongTinDieuTri?.thiLucKhongKinhMatTrai ||
        !thongTinDieuTri?.thiLucCoKinhMatTrai)
    ) {
      const jsonMt = JSON.parse(thongTinDieuTri?.mt);

      hopitalizeForm.setFieldsValue({
        thiLucKhongKinhMatTrai:
          jsonMt?.ucva1 &&
          jsonMt?.ucva1 + (jsonMt?.ucva1Value ? `(${jsonMt?.ucva1Value})` : ""),
        thiLucCoKinhMatTrai:
          jsonMt?.glasses1 &&
          jsonMt?.glasses1 +
            (jsonMt?.glasses1Value ? `(${jsonMt?.glasses1Value})` : ""),
      });
    } else {
      hopitalizeForm.setFieldsValue({
        thiLucKhongKinhMatTrai: thongTinDieuTri?.thiLucKhongKinhMatTrai,
        thiLucCoKinhMatTrai: thongTinDieuTri?.thiLucCoKinhMatTrai,
        taiKham: convertIosStringToDate2(thongTinDieuTri?.taiKham),
      });
    }

    //Xử lý khám mắt
    if (
      thongTinDieuTri?.khamMat &&
      (!thongTinDieuTri?.khamMatMatPhai || !thongTinDieuTri?.khamMatMatTrai)
    ) {
      CheckDataKhamMat(
        thongTinDieuTri.khamMat,
        setDataEditorLeft,
        setDataEditorRight
      );
    }

    if (thongTinDieuTri?.khamMatMatPhai) {
      setDataEditorRight(thongTinDieuTri.khamMatMatPhai);
    }
    if (thongTinDieuTri?.khamMatMatTrai) {
      setDataEditorLeft(thongTinDieuTri.khamMatMatTrai);
    }
    //******************** hết***************** */
    // xử lý nhãn áp
    // if (
    //   thongTinDieuTri?.nhanAp &&
    //   (!thongTinDieuTri?.nhanApMatPhai || !thongTinDieuTri?.nhanApMatTrai)
    // ) {
    //   const jsonNhanApLeft = JSON.parse(thongTinDieuTri.nhanAp);

    //   const nhanApMatTrai = jsonNhanApLeft?.['"intraocularPressureLeft"']?.[0];
    //   if (nhanApMatTrai) {
    //     hopitalizeForm.setFieldsValue({
    //       nhanApMatTrai:
    //         nhanApMatTrai.mmHg &&
    //         nhanApMatTrai.mmHg + "mmHg - lúc" + nhanApMatTrai.min,
    //     });
    //   }

    //   const nhanApMatPhai = jsonNhanApLeft?.['"intraocularPressureRight"']?.[0];
    //   if (nhanApMatPhai) {
    //     hopitalizeForm.setFieldsValue({
    //       nhanApMatPhai:
    //         nhanApMatPhai.mmHg &&
    //         nhanApMatPhai.mmHg + "mmHg - lúc " + nhanApMatPhai.min,
    //     });
    //   }
    // }
    //Check BMI
    if (thongTinDieuTri?.chieuCao && thongTinDieuTri?.canNang) {
      let tmp = Number(canNang) / Math.pow(Number(chieuCao) / 100, 2);
      if (tmp && !isNaN(tmp) && isFinite(tmp))
        hopitalizeForm.setFieldValue("bmi", tmp.toFixed(1));
      else hopitalizeForm.setFieldValue("bmi", null);
    }
  }, [thongTinDieuTri]);

  // Xử lý khi có nhiều trường ở khám mắt
  useEffect(() => {
    if (dataEditorRight) {
      const state = convertToEditor(dataEditorRight);
      setEditorStateRight(EditorState.createWithContent(state));
    }
  }, [dataEditorRight]);

  useEffect(() => {
    if (dataEditorLeft) {
      const state = convertToEditor(dataEditorLeft);
      setEditorStateLeft(EditorState.createWithContent(state));
    }
  }, [dataEditorLeft]);
  const convertToEditor = (htmlString) => {
    const blockFromHTMl = convertFromHTML(htmlString);
    const state = ContentState.createFromBlockArray(
      blockFromHTMl.contentBlocks,
      blockFromHTMl.entityMap
    );

    return state;
  };
  // ************************

  const onPrintTienPhau = (isView) => {
    tienPhauPrintRef.current.openModal();
    tienPhauPrintRef.current.setDataPhieu({
      ...thongTinBN,
      ...thongTinDieuTri,
      idChanDoan: thongTinDieuTri?.icdChanDoan,
      chanDoan: thongTinDieuTri?.chanDoan,
    });
    tienPhauPrintRef.current.setIsView(isView);
    tienPhauPrintRef.current.setDataPhieuTienPhau(
      thongTinDieuTri?.phieuTienPhau
    );
  };
  const handleEditPhieuTienPhau = (isView) => {
    tienPhauRef.current.openModal();
    tienPhauRef.current.setDataPhieu({
      ...thongTinBN,
      ...thongTinDieuTri,
      idChanDoan: thongTinDieuTri?.icdChanDoan,
      chanDoan: thongTinDieuTri?.chanDoan,
    });
  };
  const onAddTienPhau = (isView) => {
    tienPhauRef.current.openModal();
    tienPhauRef.current.setDataPhieu({
      ...thongTinBN,
      ...thongTinDieuTri,
      idChanDoan: thongTinDieuTri?.icdChanDoan,
      chanDoan: thongTinDieuTri?.chanDoan,
    });
    tienPhauRef.current.setIsView(isView);
    tienPhauRef.current.setDataPhieuTienPhau(thongTinDieuTri?.phieuTienPhau);
  };

  useEffect(() => {
    getIcdList();
    fetchDanhMucGiuongBenh({ page: 1, limit: 9999 });
    fetchDanhMucPhongBenh({ page: 1, limit: 9999 });
  }, []);

  // console.log("🚀 ~ TreatmentInfo ~ checkChangeValue:", checkChangeValue);
  const handleChange = (changedValues, allValues) => {
    // console.log("🚀 ~ handleChange ~ changedValues:", changedValues);
    if (changedValues) {
      // setCheckChangeValue(true);
      dispatch(setIsChangetab(true));
    }
  };

  // useEffect(() => {

  //     if (checkChangeValue) {

  //       return;
  //     } else {
  //       dispatch(setActiveKey(activeTab));
  //       dispatch(setIsChangetab(false));

  //     }

  // }, [checkChangeValue]);

  return (
    <Spin spinning={loading}>
      <div className="come-in-hospital-info">
        <Form form={infoForm}>
          <div className="container">
            <TypographyCommon title={"Thông tin bệnh nhân"} />
            <Space direction="vertical" size={"middle"}>
              <PatientInfoCommon data={thongTinBN} fields={patientInfo} />
              <Row justify={"end"}>
                <Space>
                  {btnComInHospital.map((item) => (
                    <Col>
                      <Button
                        icon={item.icons}
                        danger={item.danger}
                        type={item.type}
                        className={item.className}
                        onClick={item.onClick}
                        disabled={!(idDDNT === 0 || Boolean(idDDNT))}
                      >
                        {item.title}
                      </Button>
                    </Col>
                  ))}
                </Space>
              </Row>
            </Space>
          </div>
        </Form>
        <div className="container">
          <Form form={hopitalizeForm} onValuesChange={handleChange}>
            <TypographyCommon
              title={"Thông tin khám nhập viện"}
            ></TypographyCommon>
            <Row gutter={[16, 8]}>
              <InputFields
                data={dataInfoHospitalise(hopitalizeForm, icdList)}
              />
            </Row>
            <Row gutter={[16, 8]}>
              <div style={{ fontWeight: "bold", padding: "10px 0 10px 8px" }}>
                Tiền sử bệnh
              </div>
              <InputFields data={dataAnamnesis} />
            </Row>
            <Space
              size={"middle"}
              direction="vertical"
              style={{ width: "100%" }}
            >
              <Row gutter={[16, 8]}>
                <div style={{ fontWeight: "bold", padding: "10px 0 10px 8px" }}>
                  Khám xét
                </div>
                <InputFields data={dataExamine} />
              </Row>
              <Row style={{ fontWeight: "bold", paddingLeft: "8px" }}>
                <div>Khám mắt</div>
              </Row>
              <Row gutter={[16, 8]}>
                {/* <InputFields data={khamMat} /> */}
                <Col xl={12} lg={12} md={24} sm={24} className="editor">
                  <Form.Item
                    labelAlign="left"
                    label="Mắt phải"
                    name={"khamMatMatPhai"}
                    labelCol={{ xl: 4, lg: 10, md: 5, sm: 10 }}
                    wrapperCol={{ xl: 20, lg: 14, md: 19, sm: 14 }}
                  >
                    <Editor
                      editorState={editorStateRight}
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor-dieu-tri-noi-tru"
                      onEditorStateChange={onEditorStateChangeRight}
                      toolbar={fontOptions}
                    />
                  </Form.Item>
                </Col>
                <Col xl={12} lg={12} md={24} sm={24} className="editor">
                  <Form.Item
                    labelAlign="left"
                    label="Mắt trái"
                    name={"khamMatMatTrai"}
                    labelCol={{ xl: 4, lg: 10, md: 5, sm: 10 }}
                    wrapperCol={{ xl: 20, lg: 14, md: 19, sm: 14 }}
                  >
                    <Editor
                      editorState={editorStateLeft}
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor-dieu-tri-noi-tru"
                      onEditorStateChange={onEditorStateChangeLeft}
                      toolbar={fontOptions}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ fontWeight: "bold", paddingLeft: "8px" }}>
                <div>Thị lực không kính</div>
              </Row>
              <Row gutter={[16, 8]}>
                <InputFields data={thiLucKhongKinh} />
              </Row>
              <Row style={{ fontWeight: "bold", paddingLeft: "8px" }}>
                <div>Thị lực có kính</div>
              </Row>
              <Row gutter={[16, 8]}>
                <InputFields data={thiLucCoKinh} />
              </Row>
            </Space>

            {/* <Row gutter={[16, 8]}>
              <Col xl={24} style={{ fontWeight: "bold" }}>
                Nhãn áp
              </Col>
              <InputFields data={nhanAp} />
            </Row> */}
          </Form>
        </div>
        <Form form={form}>
          <div className="container">
            <TypographyCommon title={"Biên bản hội chẩn phẫu thuật"} />
            <Row gutter={[16, 8]}>
              {cstMngs.map((it) => {
                return (
                  <>
                    <Col span={12}>
                      <Row align={"middle"} gutter={8}>
                        <Col>
                          <WordSVG />
                        </Col>
                        <Col>
                          <Row>
                            <Typography.Text strong ellipsis>
                              Biên bản hội chẩn.doc
                            </Typography.Text>
                            <Row>
                              <Space
                                direction="horizontal"
                                split={<Divider type="vertical" />}
                              >
                                <Typography.Text type="secondary">
                                  Sửa lần cuối: {it.lanSuaCuoi}
                                </Typography.Text>
                                <Typography.Text type="success">
                                  Người sửa: {it.by}
                                </Typography.Text>
                              </Space>
                            </Row>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row justify={"end"}>
                        <Space align="center">
                          <Button
                            icon={<Icons.printer />}
                            onClick={() => printBBHC(it.idx, true)}
                          >
                            In phiếu
                          </Button>
                          <Button
                            icon={<Icons.edit />}
                            onClick={() => viewCST(it.idx, false)}
                          >
                            Sửa phiếu
                          </Button>
                          <Button
                            icon={<Icons.edit />}
                            onClick={() => viewCST(it.idx, true)}
                          >
                            Xem phiếu
                          </Button>
                          <Popconfirm
                            title="Bạn có muốn xoá?"
                            onConfirm={() => deleteCST(it.idx)}
                          >
                            <Button icon={<Icons.remove />}>Xóa phiếu</Button>
                          </Popconfirm>
                        </Space>
                      </Row>
                    </Col>
                  </>
                );
              })}
              <Row>
                <Consultation
                  onSave={handleSaveConsultation}
                  ref={cstRef}
                  data={thongTinBN}
                />
                <Button icon={<Icons.add />} onClick={onAddCST}>
                  Thêm biên bản
                </Button>
              </Row>
            </Row>
          </div>
          <div className="container">
            <Row>
              <TypographyCommon title={"Phiếu khám tiền phẫu"} />
            </Row>
            <Row>
              {phieuTienPhau ? (
                <>
                  <Col span={12}>
                    <Row align={"middle"} gutter={8}>
                      <Col>
                        <WordSVG />
                      </Col>
                      <Col>
                        <Row>
                          <Typography.Text strong ellipsis>
                            Phiếu khám tiền phẫu
                          </Typography.Text>
                          <Row>
                            <Space
                              direction="horizontal"
                              split={<Divider type="vertical" />}
                            >
                              <Typography.Text type="secondary">
                                Sửa lần cuối:{" "}
                                {dayjs(phieuTienPhau?.suLanCuoi).format(
                                  FORMAT_TIME.dateTime
                                )}
                              </Typography.Text>
                              <Typography.Text type="success">
                                By: {phieuTienPhau?.by}
                              </Typography.Text>
                            </Space>
                          </Row>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12}>
                    <Row justify={"end"}>
                      <Space align="center">
                        <Button
                          icon={<Icons.printer />}
                          onClick={() => onPrintTienPhau(true)}
                        >
                          In phiếu
                        </Button>
                        <Button
                          icon={<Icons.edit />}
                          onClick={() => handleEditPhieuTienPhau(true)}
                        >
                          Sửa phiếu
                        </Button>
                        {/* <Button
                        icon={<Icons.edit  />}
                        onClick={() => viewTreatment("it", true, 0)}
                      >
                        Xem phiếu
                      </Button> */}
                        {/* <Button
                                icon={<DeleteOutlined  />}
                                // onClick={() => delToDieuTri(it)}
                              >
                                Xóa phiếu
                              </Button> */}
                      </Space>
                    </Row>
                  </Col>
                </>
              ) : (
                <Row>
                  <Button
                    icon={<Icons.add />}
                    onClick={() => onAddTienPhau(false)}
                  >
                    Thêm phiếu
                  </Button>
                </Row>
              )}
            </Row>
            <PhieuTienPhau ref={tienPhauRef} onSave={handleSave} />
            <PhieuTienPhauPrint ref={tienPhauPrintRef} />
          </div>
          <div className="container">
            <Row justify={"space-between"}>
              <Col>
                <TypographyCommon title={"Tờ điều trị"} />
              </Col>
              <Col>
                <Row style={{ gap: "4px" }}>
                  <Button className="btn-sub" onClick={onPrintTDT}>
                    In tờ điều trị
                  </Button>
                  <Button className="btn-sub" onClick={onPrintPCDXN}>
                    In phiếu chỉ định
                  </Button>
                </Row>
              </Col>
            </Row>
            <Row gutter={[16, 8]}>
              {thongTinDieuTri?.toDieuTriDtoList
                ?.slice()
                ?.sort(customCompare)
                ?.map((it, idx) => {
                  let data = JSON.parse(it?.toDieuTri ?? "{}");
                  return (
                    <>
                      <Col span={12}>
                        <Row align={"middle"} gutter={8}>
                          <Col>
                            <WordSVG />
                          </Col>
                          <Col>
                            <Row>
                              <Typography.Text strong ellipsis>
                                {`Phiếu số ${data?.to + 1}`}
                              </Typography.Text>
                              <Row>
                                <Space
                                  direction="horizontal"
                                  split={<Divider type="vertical" />}
                                >
                                  <Typography.Text type="secondary">
                                    Sửa lần cuối: {data?.lanSuaCuoi ?? ""}
                                  </Typography.Text>
                                  <Typography.Text type="success">
                                    By: {data?.by ?? ""}
                                  </Typography.Text>
                                </Space>
                              </Row>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={12}>
                        <Row justify={"end"}>
                          <Space align="center">
                            {/* <Button
                            icon={<Icons.edit />}
                            onClick={() =>
                              printTreatment(it, true, data?.kind ?? 0)
                            }
                          >
                            In phiếu
                          </Button> */}
                            <Button
                              icon={<Icons.edit />}
                              onClick={() =>
                                viewTreatment(it, false, data?.kind ?? 0, true)
                              }
                            >
                              Sửa phiếu
                            </Button>
                            <Button
                              icon={<Icons.edit />}
                              onClick={() =>
                                viewTreatment(it, true, data?.kind ?? 0, true)
                              }
                            >
                              Xem phiếu
                            </Button>
                            <Popconfirm
                              title="Bạn có muốn xoá"
                              onConfirm={() => delToDieuTri(it)}
                            >
                              <Button icon={<DeleteOutlined />}>
                                Xóa phiếu
                              </Button>
                            </Popconfirm>
                          </Space>
                        </Row>
                      </Col>
                    </>
                  );
                })}
              {/* <Row>
                  <Button icon={<Icons.add />} onClick={onAddTreatmentSheet}>
                    Thêm biên bản
                  </Button>
                </Row> */}
              <TreatmentSheet
                onSave={handleSaveTreatment}
                ttNhanTao={thongTinDieuTri?.ttNhanTao ?? null}
                ref={treatmentRef}
              />
              <TreatmentTypeModal
                ref={treatmentTRef}
                handleConfirm={handleTTConfirm}
              />
              <Button icon={<Icons.add />} onClick={() => onSelectTType(false)}>
                Thêm phiếu
              </Button>
            </Row>
          </div>
          <div className="container">
            <Space style={{ width: "100%", marginBottom: 4 }}>
              <Typography.Text strong>Thông tin đơn thuốc</Typography.Text>
              <Button
                type="primary"
                onClick={() => {
                  if (thongTinDieuTri?.toDieuTriDtoList.length) {
                    phuThuRef?.current?.openModal();
                  } else Notification("warning", "Chưa thêm tờ điều trị");
                }}
              >
                Danh sách phụ thu
              </Button>
            </Space>
            <Row>
              <PrescriptionTable ref={donThuocRef} />
            </Row>
          </div>
        </Form>
        <Row>
          <div>
            <LessCondition
              ref={conditionRef}
              onSave={handleSave}
              thongTinBN={thongTinBN}
            />
          </div>
        </Row>
      </div>
      <PrintComeHospital ref={printComeHotpitalRef} />
      <ModalCustom width={1000} ref={chiDinhref}>
        <PhieuChiDinhXetNghiem ref={pCDXNRef} />
      </ModalCustom>
      <ModalCustom width={1000} ref={phuThuRef} title="Danh sách phụ thu">
        <PhuThuModal
          idPhieuKham={thongTinBN?.idPhieuKham}
          thongTinDieuTri={thongTinDieuTri}
        />
      </ModalCustom>
      <ToDieuTri ref={tDTRef} dmBuong={dmBuong} dmGiuong={dmGiuong} />
    </Spin>
  );
};

export default TreatmentInfo;
